const STORAGE_KEY = "perfectTodo_templateReloginGate";

export function markTemplateReloginGate() {
  sessionStorage.setItem(STORAGE_KEY, "1");
}

export function clearTemplateReloginGate() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function isTemplateReloginGateOpen() {
  return sessionStorage.getItem(STORAGE_KEY) === "1";
}

/** ログイン成功後、リダイレクト先が /templates 配下ならゲートを立てる */
export function markTemplateReloginGateIfRedirectIsTemplates(loginSearch) {
  const searchParams = new URLSearchParams(loginSearch);
  const redirectPath = searchParams.get("redirect") || "/";
  const pathOnly = redirectPath.split("?")[0];
  if (pathOnly === "/templates" || pathOnly.startsWith("/templates/")) {
    markTemplateReloginGate();
  }
}
